var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBCconsumerFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1464",
    opacity: 0.06,
    d: "M1920.156,39.28766c-31.02564,16.15887-91.33045,41.4544-149.07715,30.82464C1688.53491,54.918,1387.76489,45.418,1341.82593,45.418S980.61719,75.75,861.48706,61.10449,593.84082,13.96,364.075,54.68066,121.554,43.14648,17.64307,45.418c-6.23706.13635-12.05.45386-17.48706.9223v38.982h1920Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1464",
    opacity: 0.06,
    d: "M1920.156,50.15778C1900.88086,56.1723,1864.2301,64.09,1809.66187,61.5c-85.09791-4.03906-58.21094-27.27832-168.033-26.73926S1338.32666,97.78906,1200.26489,61.5,780.032,20.7793,558.603,61.5,187.39722,32.48926,87.2561,34.76074C26.65063,36.13544,6.5697,55.496.156,70.57019V85.32226h1920Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCconsumerFooter);
export default __webpack_public_path__ + "static/media/BCconsumer-footer.83511304aaf683a1fd37d29d4e05013c.svg";
export { ForwardRef as ReactComponent };